import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-front-data477',
  templateUrl: './front-data477.component.html',
  styleUrls: ['./front-data477.component.css']
})
export class FrontData477Component {

  constructor(private readonly titleService: Title) { 
    this.titleService.setTitle('477 Data | JSi360');
  }
}
